import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../../../contexts/UserContext';
import { LoginForm } from '../../components/LoginForm';

const Login = () => {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser && currentUser?.username !== null) navigate('/home');
  }, [currentUser, navigate]);
  return (
    <div className="flex overflow-hidden">
      <div id="main-content" className="h-full w-full xs:px-5 pt-20">
        <main>
          <div className="py-10 lg:w-2/3 xl:w-1/3 mx-auto">
            <div className="bg-white rounded-xl py-10 px-10 xl:px-20 flex flex-col items-center justify-center shadow-sm">
              <div className="flex mb-4">
                <h1 className="text-lg xs:text-4xl font-analogue">Log In</h1>
              </div>
              <LoginForm
                onLoginSuccess={(user) => {
                  setCurrentUser(user);
                  navigate('/home');
                }}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Login;
